var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarScheduleFill = function SvgCalendarScheduleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 3.75v1.5h-3A.75.75 0 0 0 5 6v12c0 .414.336.75.75.75h5.816A6 6 0 0 1 20 10.316V6a.75.75 0 0 0-.75-.75h-3v-1.5h-1.5v1.5h-4.5v-1.5zm12 11.25a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-5.25-3v3.31l1.72 1.72 1.06-1.06L17 14.69V12z"
  })));
};
export default SvgCalendarScheduleFill;